import { actionTypes } from '@intake24/common/prompts';

export const gtmEvents = [
  ...actionTypes,
  'noMoreInformation',
  'selectFoodCategory',
  'restart',
  'surveyLogin',
  'surveyHome',
  'surveyLogout',
  'foodSearch',
  'recallSubmitted',
  'startRecall',
  'cancelRecall',
  'selectFAQ',
  'preSurveyLinkShown',
  'preSurveyLinkClicked',
  'postSurveyLinkShown',
  'postSurveyLinkClicked',
  'navigateCarousel',
] as const;
type GtmEvent = (typeof gtmEvents)[number];

// Event category for Google Analytics, deduced from the prompt section.
export const gtmSections = [
  'preMeals',
  'postMeals',
  'submission',
  'preFoods',
  'foods',
  'postFoods',
  'foodsDeferred',
] as const;
export type GtmSection = typeof gtmSections[number];

export type GtmEventParams = {
  event?: GtmEvent; // event type, e.g. GtmEvents.DeleteMeal, which is 'deleteMeal'. Open to new event types
  section?: GtmSection | string;
  meal?: string;
  food?: string; // food name, e.g. "Fresh fruit salad"
  food_category?: string; // food category, e.g. "Ham / gammon"
  action?: string; // specify action for interactive custom events (optional)
  prompt_id?: string; // type of prompt, e.g. "meal-add-prompt"
  label?: string; // auxillary data for custom events
  search_term?: string;
  search_count?: number;
  percent_scrolled?: number; // 0-100 percent scrolled refers to the percentage of the page that has been viewed so far
  noninteraction?: boolean; // false if an event is not tracked as a user-generated action
  uxSessionId?: string; // unique session id generated by the survey app to help correlating DB records
  uxUserId?: string; // user id generated by in the backend
  search_term_order?: number; // order of search term in the search history, e.g. 1 for first search term, 2 for second search term, etc.
  search_results_count?: number; // number of search results returned for the search term
  faq_section_title?: string; // title of the FAQ section
  faq_question_title?: string; // title of the FAQ question
  link_kind?: 'dietary_feedback' | 'follow_up';
  previous_selected_option?: string; // controlled option value, never free text
};
